import auth from './auth';
import cognitoAuth from './cognitoAuth';

export default {
  ...auth,
  ...cognitoAuth,
};

export {
  AUTH_COOKIE_NAME,
  LOCK_SECRET_NAME,
  REFERRER_COOKIE_NAME,
  USER_COOKIE_NAME,
  USER_DISPLAY_NAME_COOKIE_NAME,
  FAR_FUTURE_DATE,
} from './auth';
